const API = 'https://rnd.mypubs.ru/api.php';
const IS_DEBUG = false;
function getRating(url, container) {
    $.post(API, {
        url,
        cmd: "rating"
    }).done(function(data) {
        if (IS_DEBUG) console.log(data);
        if (data.length === 0) addRating(0, 0, container);
        else {
            var info = JSON.parse(data);
            addRating(info.sum, info.count, container);
        }
    }).fail(function(data) {
        if (IS_DEBUG) console.error(data);
        addRating(0, 0, container);
    });
}
function addRating(sum, count, item) {
    if (count === 0 || sum === undefined || sum === 0) {
        $(item).html(`${stars(0)}`);
        $(item).attr('value', '-1');
        return;
    }
    var avg = sum / count;
    $(item).html(`${stars(avg)} ${avg.toFixed(1)}`);
    $(item).attr('value', avg.toFixed(1));
}
function getBarStatus(container) {
    const worklist = container.data('worklist').split(';;;').filter(Boolean);
    const days = [
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431",
        "\u0432\u0441"
    ];
    const now = new Date();
    const currentDay = (now.getDay() + 6) % 7;
    const currentMinutes = currentDay * 1440 + now.getHours() * 60 + now.getMinutes();
    let isOpen = false;
    let closesInMinutes = Infinity;
    worklist.forEach((item)=>{
        const [dayRange, timeRange] = item.split('|');
        const [openTime, closeTime] = timeRange.split(/\s*[–-]\s*/).map((time)=>{
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        });
        const range = dayRange.toLowerCase().split(/\s*[–-]\s*/);
        const startDay = days.indexOf(range[0]);
        const endDay = days.indexOf(range[1] || range[0]);
        const dayCount = (endDay - startDay + 7) % 7 + 1;
        for(let dayOffset = 0; dayOffset < dayCount; dayOffset += 1){
            const openingDay = (startDay + dayOffset) % 7;
            const openingMinutes = openingDay * 1440 + openTime;
            const closingMinutes = openingMinutes + (closeTime <= openTime ? 1440 - openTime + closeTime : closeTime - openTime);
            if (currentMinutes >= openingMinutes && currentMinutes < closingMinutes) {
                isOpen = true;
                closesInMinutes = Math.min(closesInMinutes, closingMinutes - currentMinutes);
            }
        }
    });
    const isClosingSoon = isOpen && closesInMinutes <= 60;
    return {
        isClosingSoon,
        isOpen
    };
}
function stars(rating) {
    var value = Math.min(5, Math.max(0, Number(rating) || 0));
    var full = Math.floor(value);
    var half = value - full >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    return '<i class="fa-solid fa-star"></i>'.repeat(full) + '<i class="fa-solid fa-star-half-stroke"></i>'.repeat(half) + '<i class="fa-regular fa-star"></i>'.repeat(empty);
}
function setMaps() {
    var list = $('article');
    list.each(function(index, item) {
        var name = $(item).find('.bar-title a').text();
        var icon = $(item).find('.map-marker').data('src');
        var location = $(item).find('.map-location').val();
        if (location) {
            const frame = $(item).find('.map-frame');
            const [lat, lng] = location.split(',').map(Number);
            const map = L.map(frame[0]).setView([
                lat,
                lng
            ], 15);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OSM'
            }).addTo(map);
            const marker = icon ? L.icon({
                iconUrl: icon,
                iconSize: [
                    40,
                    40
                ],
                iconAnchor: [
                    20,
                    40
                ],
                popupAnchor: [
                    0,
                    -40
                ]
            }) : new L.Icon.Default();
            L.marker([
                lat,
                lng
            ], {
                icon: marker
            }).addTo(map).bindPopup(name);
            $(item).data('leaflet-map', map);
            $(item).find('.leaflet-control-attribution a, .leaflet-control-attribution span').hide();
        }
    });
    refreshMaps();
}
function refreshMaps() {
    $('article:visible').each(function() {
        const map = $(this).data('leaflet-map');
        if (map) setTimeout(()=>{
            map.invalidateSize();
        }, 0);
    });
}
function setRatings() {
    var list = $('article');
    list.each(function(index, item) {
        var container = $(item).find('.bar-rating');
        var url = $(item).find('.bar-title a').attr('href');
        if (url) getRating(url, container);
    });
}
function setStatuses() {
    var list = $('article');
    list.each(function(index, item) {
        var status = $(item).find('.bar-hours');
        if (status.length > 0) {
            var info = getBarStatus(status);
            $(status).html(info.isClosingSoon ? "\u0421\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0440\u043E\u0435\u0442\u0441\u044F" : info.isOpen ? "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u0441\u0435\u0439\u0447\u0430\u0441" : "\u0417\u0430\u043A\u0440\u044B\u0442\u043E");
        }
    });
}
window.mypubs = window.mypubs || {};
Object.assign(window.mypubs, {
    API,
    getBarStatus,
    stars,
    addRating,
    getRating,
    setMaps,
    refreshMaps,
    setRatings,
    setStatuses
});

//# sourceMappingURL=common.ec9a93b5.js.map
